import MarqueeRow from "@/components/MarqueeRow";
import { proxied } from "@/lib/api";

const Experts = ({ items = [], settings = {}, speed = 4 }) => {
  if (!items.length) return null;
  return (
    <section id="experts" className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
      <div className="text-center mb-10 md:mb-14">
        <div className="text-[#8B2323] text-xs md:text-sm tracking-[0.4em] uppercase mb-3">{settings.experts_kicker || "Guided by Masters"}</div>
        <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-[#2D2825]">{settings.experts_title || "Panel Experts of Rudralife"}</h2>
        <p className="mt-4 text-[#5C544F] max-w-2xl mx-auto">
          {settings.experts_subtitle || "Step into an exclusive discussion with our expert panel and unlock ancient Rudraksha wisdom for the modern seeker."}
        </p>
        <div className="h-[2px] w-16 bg-[#D4AF37] mt-6 mx-auto" />
      </div>

      <MarqueeRow direction="left" speed={30} gap={20} noPause>
        {items.map((e) => (
          <div
            key={e.id}
            className="group relative flex-shrink-0 w-[220px] md:w-[260px] rounded-2xl overflow-hidden bg-white border border-[rgba(45,40,37,0.08)] hover:shadow-[0_20px_40px_rgba(139,35,35,0.1)] transition-all"
          >
            <div className="aspect-[3/4] overflow-hidden bg-[#F3EBE1] relative">
              <img
                src={proxied(e.image)}
                alt={e.name}
                draggable={false}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 pointer-events-none"
              />
              <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black/70 to-transparent" />
              <div className="absolute bottom-4 left-4 right-4 text-white">
                <h3 className="font-serif text-lg leading-tight">{e.name}</h3>
                <div className="text-[10px] tracking-widest uppercase text-[#D4AF37] mt-1">{e.role}</div>
              </div>
            </div>
            <div className="p-4">
              <p className="text-xs text-[#5C544F] leading-relaxed line-clamp-4">{e.bio}</p>
            </div>
          </div>
        ))}
      </MarqueeRow>
    </section>
  );
};

export default Experts;
